import React, { Fragment } from 'react';
import { Controller, ControllerRenderProps, UseFormReturn } from 'react-hook-form';

import { Box, IconButton, TextField, TextFieldProps, Tooltip, Typography } from '@mui/material';

import { CommonFieldProps } from './props/FieldProps';
import { Title } from './Widgets/Title';
import { translate } from 'react-jhipster';
import { getNestedValue } from '../utils';
import { HelpOutline } from '@mui/icons-material';

export interface StandardTextFieldProps extends CommonFieldProps<'text-field'> {
  attribute: Required<CommonFieldProps<'text-field'>>['attribute'];
}

export default function StandardTextField(props: {
  field: StandardTextFieldProps;
  methods: UseFormReturn;
  hideTitle?: boolean;
}) {
  const {
    field: fieldConfig,
    methods: {
      control,
      getValues,
      setValue,
      trigger,
      formState: { errors },
    },
    hideTitle,
  } = props;

  const componentProps = (fieldConf: StandardTextFieldProps, field: ControllerRenderProps): TextFieldProps => {
    return {
      id: fieldConf.attribute,
      fullWidth: true,
      size: 'small',
      variant: 'outlined',
      label: fieldConf.label && translate(fieldConf.label, null, fieldConf.label),
      error: !!getNestedValue(errors, fieldConf.attribute),
      helperText: <>{getNestedValue(errors, fieldConf.attribute)?.message}</>,
      onKeyDown(event) {
        if (event.key === 'Enter') {
          trigger(fieldConf.attribute);
        }
      },
      ...fieldConf.props,
      ...field,
      value: field.value || '',
    };
  };

  const { titleOptionalMarker, titleTooltip, titleTooltipProps, title, validations } = fieldConfig;
  const isRequired = validations && validations.filter(f => f[0] === 'required').length > 0;

  return (
    <Controller
      name={fieldConfig.attribute}
      control={control}
      render={({ field }) => (
        <Fragment>
          {!hideTitle && fieldConfig.title && <Title field={fieldConfig} />}

          {title && title !== '' ? (
            <TextField {...componentProps(fieldConfig, field)} />
          ) : (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <TextField {...componentProps(fieldConfig, field)} />
              <Box flexGrow={1}></Box>
              {titleOptionalMarker && !isRequired && (
                <Typography color="gray">{translate('stepper.optional', null, 'Optional')}</Typography>
              )}
              {titleTooltip && (
                <Tooltip {...titleTooltipProps} title={titleTooltip} sx={{ ...titleTooltipProps?.sx }}>
                  <IconButton>
                    <HelpOutline fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          )}
        </Fragment>
      )}
    />
  );
}
